import { Button } from 'react-bootstrap';
import combineClasses from 'classnames';
import styles from './GreyButton.module.scss';

interface Props {
  small?: boolean;
  disabled?: boolean;
  minWidth?: boolean;
  [k: string]: string | unknown | undefined;
}

const GreyButton = ({ small, disabled, minWidth, ...otherProps }: Props) => (
  <div
    className={combineClasses({
      [`${styles.greyButton}`]: true,
      [`${styles.small}`]: small,
      [`${styles.disabled}`]: disabled,
      [`${styles.minWidth}`]: minWidth,
    })}
  >
    <Button {...otherProps}>{otherProps.children}</Button>
  </div>
);

export default GreyButton;
